/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, LinearProgress, Typography } from '@material-ui/core';
import { green, orange } from '@material-ui/core/colors';

const useStyles = makeStyles({
  colorPrimary: {
    backgroundColor: '#eeeeee'
  },
  barColorPrimary: {
    backgroundColor: props => (props.value >= 100 ? green[500] : orange[500])
  }
});

function CustomLinearProgress(props) {
  if (props.showLabel) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  return <LinearProgress variant="determinate" {...props} />;
}

CustomLinearProgress.propTypes = {
  value: PropTypes.number.isRequired,
  showLabel: PropTypes.bool
};

const ColoredLinearProgress = ({ value, ...props }) => {
  const currentValue = value > 100 ? 100 : value;
  const { colorPrimary, barColorPrimary } = useStyles({
    value: currentValue
  });
  return (
    <CustomLinearProgress
      {...props}
      value={currentValue}
      variant="determinate"
      classes={{
        colorPrimary,
        barColorPrimary
      }}
    />
  );
};

ColoredLinearProgress.propTypes = {
  value: PropTypes.number.isRequired
};

export default ColoredLinearProgress;
